import React, {useEffect, useState} from "react";
import AutoCompleteInput from "../sharedFormComponents/AutoCompleteInput";

const FilterAutoComplete = ({ options, selected, label, field, multiple, handleOnChange,disabled, handleInputChange, ...props }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState(selected);

    useEffect(() => {
        setSelectedOptions(selected)
    }, [selected]);

    const changeSelectedOption = (options) => {
        setSelectedOptions(options);
        handleOnChange(options)
    }

    const handleInputChangeAutocomplete = (event, field) => {
        if (handleInputChange) handleInputChange(event, field)
    }

    return (
        <AutoCompleteInput
            variant={props.variant || "outlined"}
            open={isOpen}
            disabled={disabled}
            handleOpen={(open) => setIsOpen(open)}
            selectedValues={selectedOptions}
            handleOnChangeAutocomplete={(field, value) => changeSelectedOption(value)}
            handleInputChangeAutocomplete={handleInputChangeAutocomplete}
            value={selectedOptions}
            multiple={multiple}
            label={label}
            field={field}
            options={options}
            {...props}
        />
    )
}

export default FilterAutoComplete;